import i18n from 'modules/core/lib/i18n'

import de from './de.json'
import en from './en.json'
import es from './es.json'
import fr from './fr.json'
import it from './it.json'
import nl from './nl.json'
import pt from './pt.json'

interface OptionType {
  value: string
  label: string
}
interface CountryList {
  [key: string]: OptionType[]
}

const countryList = {
  en,
  'en-gb': en,
  es,
  'es-mx': es,
  sv: es,
  pt,
  'pt-br': pt,
  fr,
  'fr-ng': fr,
  it,
  nl,
  de,
}

export const countries = (locale?: string | null) => {
  return (countryList as CountryList)[locale as keyof typeof countryList] || countryList.en
}

export const countryName = (countryCode: string | undefined, locale: string = i18n.locale) => {
  const value = (countryCode && countryCode.toLowerCase()) ?? ''
  const country = countries(locale).find((country) => country.value === value)

  return country ? country.label : ''
}

// TODO: Catalan, Esperanto and "el" are missing on the api https://restcountries.com/v3.1/all
export default countryList
